import { Component } from '@angular/core';

import {FiltersService} from './filters.service';
import {ApiService} from './../shared/api.service';

@Component({
    selector: 'filters-component',
    templateUrl: 'filters.component.html'
})
export class FiltersComponent {
    panelOpen = false;
    constructor(private fs: FiltersService, private api: ApiService) {
    }
    togglePanel() {
        this.panelOpen = !this.panelOpen;
    }
    matcherComp(option, selected) {
        return option && selected ? option.name === selected.name : option === selected;
    }
    fieldComp(option, selected) {
        return option && selected ? option.column === selected.column : option === selected;
    }    
}


// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/assignments/filters.component.ts